export default __webpack_public_path__ + "static/ride-e0f0d2619a96b71673a6f5e7782ab33a.jpg";